import { defineBuiltinRole } from './types.js';

/**
 * The role every person has when using an application as an end user. It bundles no policies
 * yet: roles aren't attached to anything, and what an end user may do in each application is
 * defined as applications adopt roles.
 */
export const endUserRole = defineBuiltinRole({
  key: 'builtin:end-user',
  name: 'End User',
  description: 'A person using an application, with no management app access.',
  policies: [],
});
